// Vendor
import 'lazysizes';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'simplebar';
import $ from 'jquery';
import hoverintent from 'hoverintent';

// Polyfills
import 'focus-within-polyfill';
import ResizeObserver from 'resize-observer-polyfill';

window.ResizeObserver = ResizeObserver;
window['$'] = window.jquery = window.jQuery = $;
window.hoverintent = hoverintent;

// Core
import '@/scripts/core/bugsnag';
import '@/scripts/core/a11y';
import '@/scripts/core/object-fit-fallback';

// Components
import '@/scripts/components/utm';
import '@/scripts/components/ipdata';
import '@/scripts/components/drawers';
import '@/scripts/components/cart';
import '@/scripts/components/required-validation';
import '@/scripts/components/anchor-links';
import '@/scripts/components/quick-view';

// Snippets
import '@/scripts/snippets/mobile-nav';
import '@/scripts/snippets/modal';
import '@/scripts/snippets/custom-dropdown';

// Sections
import '@/scripts/sections/promobar';
import '@/scripts/sections/header';
import '@/scripts/sections/footer';
